const $221db3f060dbb602$export$7156baba9de26e47 = `https://js.cexplorer.io/api-static/pool/pool18gysxqfwz4j8rm3vlh6677vs9n23prvfr7gwe88mhn5uudgx9ng.json`;
const $221db3f060dbb602$export$9bec5134f7f38b3a = 10;


const $0f5d7a213243b50f$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
const $0f5d7a213243b50f$var$AJAX = async (url)=>{
    const fetchPro = fetch(url);
    const res = await Promise.race([
        $0f5d7a213243b50f$var$timeout((0, $221db3f060dbb602$export$9bec5134f7f38b3a)),
        fetchPro
    ]);
    const data = await res.json();
    if (!res.ok) throw new Error(`${data.message} (${res.status})`);
    return data;
};
const $0f5d7a213243b50f$var$widget = async ()=>{
    const dataPool = await $0f5d7a213243b50f$var$AJAX((0, $221db3f060dbb602$export$7156baba9de26e47));
    console.log(dataPool);
    // Pour que le bouton copier marche
    navigator.clipboard.writeText(dataPool.data.pool_id); // browser copy
    document.querySelector("[data-name=pool-id]")?.prepend(dataPool.data.pool_id);
    document.querySelector("[data-name=pool-title]")?.append(dataPool.data.db_name);
    document.querySelector("[data-name=pool-updated]")?.append(dataPool.data.updated);
    document.querySelector("[data-name=pool-owners]")?.append("1");
    document.querySelector("[data-name=pool-fees-margin]")?.append(dataPool.data.tax_ratio.toString() + "%");
    document.querySelector("[data-name=pool-fees-fixed]")?.append((dataPool.data.tax_fix / 1000000).toString());
    document.querySelector("[data-name=pool-fees-real]")?.append(dataPool.data.tax_real.toFixed(2));
    document.querySelector("[data-name=pool-roa-actual]")?.append(dataPool.data.roa.toString());
    document.querySelector("[data-name=pool-roa-lifetime]")?.append(dataPool.data.roa_lifetime.toString());
    document.querySelector("[data-name=pool-delegators]")?.append(dataPool.data.delegators.toString());
    document.querySelector("[data-name=pool-active_stake]")?.append(Math.round(dataPool.data.stake_active / 1000000).toString());
    document.querySelector("[data-name=pool-pledge]")?.append((dataPool.data.pledge / 1000000).toString());
};
$0f5d7a213243b50f$var$widget();


//# sourceMappingURL=index.546679c3.js.map
